import { useCallback } from 'react';
import { MenuItem } from 'components/dropdowns/RMDropdown';
import { KeyboardShortcutsLables } from 'components/customComponents/TreeControl/TreeControlHeader/constants';
import { ESearchResultRightClickAction } from 'components/searchAndFilter/constants';

export type SearchResultRightClickActions = {
  open: () => void;
  copy: () => void;
  singleDropReport: () => void;
  isOpenDisabled: boolean;
  isCopyDisabled: boolean;
  isSingleDropReportDisabled: boolean;
};

export const useSearchResultRightClickMenuItems = () => {
  const getSearchResultRightClickMenuItems = useCallback(
    (actions: SearchResultRightClickActions): MenuItem[] => {
      const {
        open,
        copy,
        singleDropReport,
        isOpenDisabled,
        isCopyDisabled,
        isSingleDropReportDisabled,
      } = actions;

      return [
        {
          label: ESearchResultRightClickAction.Open,
          onClick: open,
          isDisabled: isOpenDisabled,
        },
        {
          label: ESearchResultRightClickAction.Copy,
          onClick: copy,
          isDisabled: isCopyDisabled,
          subLabel: KeyboardShortcutsLables.Copy,
        },
        {
          label: ESearchResultRightClickAction.SingleDropReport,
          onClick: singleDropReport,
          isDisabled: isSingleDropReportDisabled,
        },
      ];
    },
    [],
  );

  return { getSearchResultRightClickMenuItems };
};
